import styled from 'styled-components';
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 24px;
`;
export const FeaturesContainer = styled.div `
  margin-bottom: 20px;
  gap: 4px;
  display: flex;
  flex-direction: column;
`;
export const PlanOptionsContainer = styled.div `
  position: relative;
`;
